import script from "./CTournamentStatusIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTournamentStatusIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./CTournamentStatusIndicator.vue?vue&type=style&index=0&id=4bc49d48&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc49d48"]])

export default __exports__